import { render, staticRenderFns } from "./SaveStatus.vue?vue&type=template&id=64f79abc&scoped=true&"
import script from "./SaveStatus.vue?vue&type=script&lang=ts&"
export * from "./SaveStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SaveStatus.vue?vue&type=style&index=0&id=64f79abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f79abc",
  null
  
)

export default component.exports